import React, { Component } from 'react';

import FallbackImg from './FallbackImg';
import { classes } from '../CUtil';

class Logo extends Component {
	render() {
		const vsizes = [24, 60];
		const size = this.props.size || 24;
		var vsize;
		for (const vsz of vsizes) if (vsz >= size) vsize = vsz;
		const exchange = this.props.exchange.toUpperCase();
		var version;
		const ticker = this.props.ticker.toUpperCase();
		const logo_group = {"NASDAQ": "US", "NYSE": "US"}[exchange] || exchange;

		/* Version control for the different logo groups */
		switch(logo_group) {
			case "US":
				version = 1;
				break;
			case "CRYPTO":
				version = 1;
				break;
			default:
				version = 0;
		}

		const src_for_size = (size) => `https://static.aktiedysten.dk/logos/${logo_group}/${ticker}-${size}px-${version}.png`;
		const src = src_for_size(vsize);
		const src_set = `${src_for_size(vsize)} 1x, ${src_for_size(vsize*2)} 2x`;
		const class_name = classes("ad_logo", this.props.className);
		const DEFAULT = "https://static.aktiedysten.dk/logos/DEFAULT-1.svg";
		const sizepx = size + "px";
		return <FallbackImg alt={ticker} className={class_name} src={src} srcSet={src_set} style={{maxWidth: sizepx, maxHeight: sizepx}} fallbackSrc={DEFAULT}/>
	}
}

export default Logo;



// WEBPACK FOOTER //
// ./src/c/Logo.js